export default {"src":"/_next/static/media/googlepay.8901b9ca.svg","height":32,"width":62,"blurWidth":0,"blurHeight":0};